import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import he from 'he';
import * as lib from '~/dependencies';
import * as actions from '~/store/actions';
import * as Loaders from '~/components/Loaders';
import { Container, RowNotes, NotesContainer, Title } from './styles';

export default function ShowNotes({ callId, sipCallId }) {
  // SELECTORS
  const loading = useSelector(state => state.draft?.loading);
  const allNotes = useSelector(state => state.draft?.notes);
  // MEMOs
  const callIdMemo = useMemo(() => callId, [callId]);

  // HOOKS
  const dispatch = useDispatch();
  const { t } = lib.useTranslation();

  const callNotes = allNotes?.filter(e => e.call_id === callIdMemo)?.reverse();

  const today = new Date();
  const dateNow = lib.dayjs(today).format('DD MMMM YYYY');

  // EFFECTS
  useEffect(() => {
    if (callIdMemo) {
      const standardCallId = String(callIdMemo?.raw || callIdMemo).replaceAll(
        '*',
        '.'
      );

      dispatch(actions.getNotesByCallId(standardCallId, sipCallId));
    }
  }, [dispatch, callIdMemo, sipCallId]);

  return (
    <Container className="showNotes">
      {loading ? (
        <div className="note-clickable">
          <Title>{t('components.showNotes.title')}</Title>
          <Loaders.Line size="290" />
        </div>
      ) : (
        <>
          {callNotes && (
            <>
              {callNotes.length > 0 && (
                <span className="title">{t('components.showNotes.title')}</span>
              )}
              <NotesContainer>
                {callNotes.map(e => (
                  <RowNotes key={Math.random()}>
                    <div className="message">
                      <p>{he.decode(e.note || '')}</p>
                    </div>
                    <div className="informations">
                      <span>{e.user_name}</span>
                      <span>-</span>
                      <div className="grouped">
                        <span>
                          {dateNow ===
                          lib.dayjs(e.note_time).format('DD MMMM YYYY')
                            ? `Today ${lib
                                .dayjs(e.note_time)
                                .format('DD MMM YYYY - HH:mm')}`
                            : lib
                                .dayjs(e.note_time)
                                .format('ddd DD MMM YYYY - HH:mm')}
                        </span>
                      </div>
                    </div>
                  </RowNotes>
                ))}
              </NotesContainer>
            </>
          )}
        </>
      )}
    </Container>
  );
}

ShowNotes.defaultProps = {
  callId: null,
  sipCallId: null,
};

ShowNotes.propTypes = {
  callId: lib.PropTypes.string,
  sipCallId: lib.PropTypes.string,
};
